<template>
    <div class="vehicle-info">
        <!-- 标题与生成时间 -->
        <div class="no-page-break-before"></div>
        <div class="header">
            <h3>三、车辆工作状态数据分析</h3>

        </div>
        <div class="work-status-data">
            <el-table :data="tableData" :show-header="false" :cell-class-name="tableCellClassName" border
                style="width: 100%;">
                <el-table-column prop="item" width="180" align="left" />
                <el-table-column prop="result" align="left" />
            </el-table>
        </div>
        <div class="no-page-break-before"></div>
        <VehicleSpeedData :speedChart="speedChart" :basicInfo="basicInfo" />
        <div class="no-page-break-before"></div>
        <!-- 发动机转速 -->
        <VehicleEngineSpeedData :engineRevChart="fuelType == 1 ? motorRevChart : engineRevChart" :fuelType="fuelType" />
        <div class="no-page-break-before" v-if="fuelType == 2"></div>
        <!-- 发动机负荷率 -->
        <VehicleEngineLoadRateData v-if="fuelType == 2" :engineLoadChart="engineLoadChart" />
        <div class="no-page-break-before" v-if="fuelType == 2"></div>
        <VehicleGearData v-if="fuelType == 2" :engineRevStallChart="engineRevStallChart" />
        <div class="no-page-break-before"></div>
        <VehicleEngineSpeedCompareData :speedEngineRevChart="speedEngineRevChart" />
        <div class="no-page-break-before"></div>
        <VehicleCoolingWaterTemperatureData :waterTempChart="waterTempChart" />
        <div class="no-page-break-before" v-if="fuelType == 1"></div>
        <VehicleSocData v-if="fuelType == 1" :socChart="socChart" />
        <div class="no-page-break-before" v-if="fuelType == 1"></div>
        <VehicleMcuTempertatureData v-if="fuelType == 1" :motorTempChart="motorTempChart" />
        <div class="no-page-break-before" v-if="fuelType == 1"></div>
        <VehicleBatteryCurrentData v-if="fuelType == 1" :batteryCurChart="batteryCurChart" />
        <div class="no-page-break-before" v-if="fuelType == 1"></div>
        <VehicleMotorTorqueData v-if="fuelType == 1" :motorLoadChart="motorLoadChart" />
    </div>
</template>

<script>
import VehicleSpeedData from './vehicle_speed_data.vue'
import VehicleEngineSpeedData from './vehicle_engine_speed_data.vue'
import VehicleEngineLoadRateData from './vehicle_engine_load_rate_data.vue'
import VehicleGearData from './vehicle_gear_data.vue'
import VehicleEngineSpeedCompareData from './vehicle_engine_speed_compare_data.vue'
import VehicleCoolingWaterTemperatureData from './vehicle_cooling_water_temperature_data.vue'
import VehicleSocData from './vehicle_soc_data.vue'
import VehicleMcuTempertatureData from './vehicle_mcu_tempertature_data.vue'
import VehicleBatteryCurrentData from './vehicle_battery_current_data.vue'
import VehicleMotorTorqueData from './vehicle_motor_torque_data.vue'



export default {
    name: "VehicleWorkInfo",
    components: {
        VehicleSpeedData,
        VehicleEngineSpeedData,
        VehicleEngineLoadRateData,
        VehicleGearData,
        VehicleEngineSpeedCompareData,
        VehicleCoolingWaterTemperatureData,
        VehicleSocData,
        VehicleMcuTempertatureData,
        VehicleBatteryCurrentData,
        VehicleMotorTorqueData
    },
    props: {
        fuelType: {
            type: Number,
            default: 1
        },
        basicInfo: {
            type: Object,
            default: () => ({})
        },
        speedChart: {
            type: Array,
            default: () => ([])
        },
        engineRevChart: {
            type: Array,
            default: () => ([])
        },
        engineLoadChart: {
            type: Object,
            default: () => ({})
        },
        motorRevChart: {
            type: Array,
            default: () => ([])
        },
        engineRevStallChart: {
            type: Object,
            default: () => ({})
        },
        speedEngineRevChart: {
            type: Array,
            default: () => ([])
        },
        waterTempChart: {
            type: Array,
            default: () => ([])
        },
        socChart: {
            type: Array,
            default: () => ([])
        },
        motorTempChart: {
            type: Array,
            default: () => ([])
        },
        batteryCurChart: {
            type: Array,
            default: () => ([])
        },
        motorLoadChart: {
            type: Array,
            default: () => ([])
        }
    },
    watch: {
        fuelType: {
            handler(newVal, oldVal) {
                if (this.fuelType == 2) {
                    var all = [{ item: "工作状态数据", result: "相应的数据和分析结果" },
                    { item: "车速(km/h)", result: "见3.1车速数据分析 图1和数据表1" },
                    { item: "发动机转速(r/min)", result: "见3.2发动机转速数据分析 图表2和数据表2" },
                    { item: "发动机负荷率", result: "见3.3发动机转速扭矩分析 图表3和数据表3" },
                    { item: "档位分析", result: "见3.4档位速度数据分析 图表4、5和数据表4" },
                    { item: "速度与转速对比分析", result: "见3.5速度与转速对比分析 数据表5" },
                    { item: "冷却水温度分析", result: "见3.6冷却水温度分析 图表6和数据表6" },]
                    this.tableData = all
                } else {
                    var all = [{ item: "工作状态数据", result: "相应的数据和分析结果" },
                    { item: "车速(km/h)", result: "见3.1车速数据分析 图1和数据表1" },
                    { item: "电机转速(r/min)", result: "见3.2电机转速数据分析 图表2和数据表2" },
                
                  
                    { item: "速度与转速对比分析", result: "见3.5速度与转速对比分析 数据表5" },
                    { item: "冷却水温度分析", result: "见3.6冷却水温度分析 图表6和数据表6" },]
                    this.tableData = all

                    var new_ = [{ item: "SOC(剩余电量)", result: "见3.7蓄电池SOC 图表7和数据表7" },
                    { item: "电池控制器温度", result: "见3.8电机电控温度图 图表8和数据表8" },
                    { item: "电池电流", result: "见3.9电池图 图表9和数据表9" },
                    { item: "电机转速", result: "见3.10电机转速 图表10和数据表10" },
                    { item: "电机扭矩", result: "见3.11电机扭矩 图表11和数据表11" }];

                    this.tableData.push(...new_)


                }
            },
            deep: true
        },

    },
    data() {
        return {

            tableData: [


            ],


        };
    },
    mounted() {
        var all = [{ item: "工作状态数据", result: "相应的数据和分析结果" },
        { item: "车速(km/h)", result: "见3.1车速数据分析 图1和数据表1" },
        { item: "发动机转速(r/min)", result: "见3.2发动机转速数据分析 图表2和数据表2" },
        { item: "发动机负荷率", result: "见3.3发动机转速扭矩分析 图表3和数据表3" },
        { item: "档位分析", result: "见3.4档位速度数据分析 图表4、5和数据表4" },
        { item: "速度与转速对比分析", result: "见3.5速度与转速对比分析 数据表5" },
        { item: "冷却水温度分析", result: "见3.6冷却水温度分析 图表6和数据表6" },]
        this.tableData = all
        if (this.fuelType == 1) {
            var new_ = [{ item: "SOC(剩余电量)", result: "见3.7蓄电池SOC 图表7和数据表7" },
            { item: "电池控制器温度", result: "见3.8电机电控温度图 图表8和数据表8" },
            { item: "电池电流", result: "见3.9电池图 图表9和数据表9" },
            { item: "电机转速", result: "见3.10电机转速 图表10和数据表10" },
            { item: "电机扭矩", result: "见3.11电机扭矩 图表11和数据表11" }];

            this.tableData.push(...new_)
        }
    },
    methods: {
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 0 || rowIndex == 0) {
                return "cell-header";
            }


        }
    }
};
</script>
<style scoped>
.vehicle-info {

    background: #ffffff;
}




.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

/* 表头单元格样式 */
.header-cell {
    background: #f5f7fa;
    font-weight: bold;
}

/* 模块标签单元格样式 */
.module-label-cell {
    background: #f5f7fa;
    font-weight: 500;
}

.el-table th {
    background: #f5f7fa;
    font-weight: 500;
    text-align: center;
}

.el-table td {
    padding: 8px 0;
    border: 1px solid #e6e6e6;
}

.speed-data-section {

    background: #ffffff;
    margin-top: 15px;
}

.chart-container {
    width: 100%;
    background: #f9fafc;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
}



.note {
    margin-top: 15px;
    line-height: 1.8;
    color: #666;
}
</style>